export const pageBreak = `
  break-before: auto;
  break-after: auto;
  break-inside: avoid;
`
